import { withQuestionnaireFuncs } from 'Context/WithQuestionnaireAnswer';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RadioGroup from 'Components/UI/BehavioralFormElement/RadioGroup';
import { noop } from 'Helpers/PropTypes';
import { withHousehold } from 'Context/HouseholdContext';
import './index.css';
import { makeHideable } from '../Hideable';
import { ContextIndex } from './FieldList';
import withViewContext from './withViewContext';

class Radio extends Component {
  constructor(props) {
    super(props);

    const {
      apiResponse: {
        attributes: { value },
      },
    } = props;

    this.state = {
      value,
      isDone: false,
    };
    this.onChange = this.onChange.bind(this);
    this.handleDisplay = this.handleDisplay.bind(this);
  }

  componentDidMount() {
    const {
      householdId,
      answerKey,
      getQuestionnaireAnswer,
      getIndexedQuestionnaireAnswer,
    } = this.props;
    const index = this.context;

    let promise;
    if (index > -1) {
      promise = getIndexedQuestionnaireAnswer(householdId, answerKey, index);
    } else {
      promise = getQuestionnaireAnswer(householdId, answerKey);
    }

    return promise
      .then((res) => {
        this.handleDisplay(res.attributes.value);
        const {
          props: { name, onChange },
        } = this;
        if (res.attributes.value) {
          onChange(name, res.attributes.value);
        } else {
          onChange(name, '');
        }

        this.setState({ value: res.attributes.value });
      })
      .finally(() => this.setState({ isDone: true }));
  }

  componentDidUpdate() {
    const { value } = this.state;
    this.handleDisplay(value);
  }

  onChange(name, value) {
    const {
      onChange, uploadValue, householdId, answerKey,
    } = this.props;

    const index = this.context;

    uploadValue(householdId, answerKey, {
      attributes: {
        value,
        index,
      },
    });

    this.setState({ value }, onChange(name, value));
  }

  handleDisplay(value) {
    const {
      props: { options },
    } = this;

    // Hide everything once:
    for (let n = 0; n < options.length; n += 1) {
      if ('showWhileSelected' in options[n]) {
        options[n].showWhileSelected.current.hide();
      }
      if ('showWhileUnselected' in options[n]) {
        options[n].showWhileUnselected.current.hide();
      }
    }

    // Show only what needs to be shown:
    for (let n = 0; n < options.length; n += 1) {
      if ('showWhileSelected' in options[n]) {
        if (options[n].id === value) {
          options[n].showWhileSelected.current.show();
        }
      }
      if ('showWhileUnselected' in options[n]) {
        if (options[n].id !== value) {
          options[n].showWhileUnselected.current.show();
        }
      }
    }
  }

  render() {
    const {
      onChange,
      props,
      state: { value, isDone },
    } = this;

    if (!isDone) {
      return null;
    }

    return (
      <div className="questionnaire-input">
        <RadioGroup {...props} onChange={onChange} value={value} />
      </div>
    );
  }
}

Radio.contextType = ContextIndex;

Radio.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      showWhileSelected: PropTypes.instanceOf(Object),
      showWhileUnselected: PropTypes.instanceOf(Object),
    }),
  ),
  uploadValue: PropTypes.func.isRequired,
  householdId: PropTypes.number.isRequired,
  answerKey: PropTypes.string.isRequired,
  label: PropTypes.string,
  apiResponse: PropTypes.instanceOf(Object),
  onChange: PropTypes.func,
  getQuestionnaireAnswer: PropTypes.func.isRequired,
  getIndexedQuestionnaireAnswer: PropTypes.func.isRequired,
};
Radio.defaultProps = {
  label: '',
  options: [],
  onChange: noop,
  apiResponse: { attributes: {} },
};

const RadioInput = withHousehold(withQuestionnaireFuncs(withViewContext(Radio)));

export default makeHideable(RadioInput);
